import {Component, OnChanges, input} from '@angular/core';
import { OrderStati } from 'libs/tm-common/src/lib/models/order.model';
import { TreatmentModel, ProfessionalTreatmentPackages } from 'libs/treatments/src/lib/models/treatment.model';
import { NgClass, NgStyle } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'lib-treatment-packages',
    templateUrl: './treatment-packages.component.html',
    styleUrls: ['./_treatment-packages.component.scss'],
    imports: [NgClass, NgStyle, TranslatePipe]
})
export class TreatmentPackagesComponent implements OnChanges {
	readonly treatment = input<TreatmentModel>(undefined);
	readonly packages = input.required<ProfessionalTreatmentPackages>();

	protected noOfOrders = 0;
	protected noPkgs;

	protected jaws = [];

	protected firstShownCorrection;
	protected prefix;
	protected suffix;

	constructor() {}

	ngOnChanges() {
  		if (!this.packages()) {
			return;
		}
		// provide selection jaws
		this.jaws = [];
		const treatment = this.treatment();
		if (treatment.product.options.uj) {
			this.jaws.push('uj');
		}
		if (treatment.product.options.lj) {
			this.jaws.push('lj');
		}

		this.noOfOrders = 0;
		if(treatment.quotation){
			this.noOfOrders = this.packages().next;
		}
		else if(treatment.orders){
			// get number of orders without the first one which is the dummy anamnese order
		treatment.orders.forEach( (order, idx) => {
			if (idx) { // skip first (anamnese order)
				if (order.status !== OrderStati.canceled) { // skip canceled orders
					this.noOfOrders++;
				}
			}
		});
		}

		// if there are more than 3 correction packages
		// then we are in the exceptional handling
		if ( this.packages().freeCorrections && this.packages().freeCorrections.length > 3)
		{
			// shortcuts
			this.noPkgs = this.packages().steps.length;
			const correctionPackages = this.packages().freeCorrections.length;

			const nextPackage = this.noOfOrders + 1;
			this.firstShownCorrection = this.noOfOrders > this.noPkgs + 2
			? this.noOfOrders - this.noPkgs - 1
			: 1;

			this.prefix = this.noOfOrders > this.noPkgs + 2
			? true
			: false;
			this.suffix = nextPackage > this.noPkgs + correctionPackages - 2
			? false
			: true;
		}
	}

	protected isRefinementPackageDelivered(index: number, checkAddCorrectionsArray: boolean): boolean {
		let currentRefinementPackage = index + this.packages()?.steps.length + this.packages()?.freeCorrections.length;

		if (checkAddCorrectionsArray && this.packages()?.addCorrections?.length){
			currentRefinementPackage += this.packages()?.addCorrections.length;
		}

		return this.noOfOrders > currentRefinementPackage;
	}

	protected getRefinementPackageNumber(index: number, checkAddCorrectionsArray: boolean): number {
		let currentRefinementPackage = index + this.packages()?.steps.length + this.packages()?.freeCorrections.length;

		if (checkAddCorrectionsArray && this.packages()?.addCorrections?.length){
			currentRefinementPackage += this.packages()?.addCorrections.length;
		}

		return currentRefinementPackage + 1;
	}
}
